import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const createLead = async (jobId) => {
    try {
        const response = await apiClient.post(API_ENDPOINTS.LEADS.CREATE_LEAD(jobId));
        return response.data;
    } catch (error) {
        console.error(`Failed to create lead for job id ${jobId}:`, error);
        console.log("Server error response:", error?.response?.data);
        throw error;
    }
};


export const getFreelancerLeadStats = async () => {
    try {
        const response = await apiClient.get(API_ENDPOINTS.LEADS.LEAD_STATS);
        return response.data;
    } catch (error) {
        console.error(`Failed to fetch freelancer stats:`, error);
        console.log("Server error response:", error?.response?.data);
        throw error;
    }
};

export const updateLeadStatus = async (leadId, status) => {
  try {
    const response = await apiClient.patch(API_ENDPOINTS.LEADS.UPDATE_STATUS(leadId), { status });
    return response.data;
  } catch (error) {
    console.error(`Failed to update lead status for lead id ${leadId}:`, error);
    console.log("Server error response:", error?.response?.data);
    throw error;
  }
};